import { IKnmOrder } from 'APIPackage/KnmModule/interfaces/IKnmOrder';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { getFullNameGuarantor } from 'KnmPmPackage/PmReasonsModule/common/getFullNameGuarantor';
import { IKnmOrderSelectOption } from 'KnmPackage/MainModule/interfaces/IKnmOrderSelectOption';

export const createKnmOrderSelectOption = (order: IKnmOrder): IKnmOrderSelectOption => {
  const date = formatDate({ date: order.date, dateFormat: DATE_FORMAT_LONG_FNS });

  return {
    ...order,
    label: `${order.number}, ${date}, ${order.title}, ${getFullNameGuarantor(order.guarantors?.[0]) || ''}`,
    id: order.recordId,
    value: order.number,
    date,
    checkBeginDate:
      order.checkBeginDate && formatDate({ date: order.checkBeginDate, dateFormat: DATE_FORMAT_LONG_FNS }),
    checkEndDate: order.checkEndDate && formatDate({ date: order.checkEndDate, dateFormat: DATE_FORMAT_LONG_FNS }),
  };
};
